module.exports = __webpack_public_path__ + "img/powered_by_google.46afd78.png";